var KnownFlags;
(function (KnownFlags) {
    KnownFlags["activityColor"] = "activityColor";
})(KnownFlags || (KnownFlags = {}));
const hasFlag = (flag, site) => {
    return site.flags[flag] || false;
};
export { KnownFlags, hasFlag };
//# sourceMappingURL=flags.js.map